import { Text, XStack } from '@frontend/web-react';
import { applyClass, concatClasses } from '@frontend/web-utils';

type TaskDetailTabHeaderProps = {
  activeTab: 'chat' | 'summary';
  setActiveTab: (tab: 'chat' | 'summary') => void;
};

export const TaskDetailTabHeader = ({ activeTab, setActiveTab }: TaskDetailTabHeaderProps) => (
  <XStack className="border-t-1 border-b-1 border-borderPrimary w-full px-lg">
    <XStack
      className={concatClasses(
        'p-md cursor-pointer border-b-1',
        applyClass(activeTab === 'chat', 'border-borderSecondary', 'border-b-transparent'),
      )}
      onClick={() => setActiveTab('chat')}
    >
      <Text
        className={concatClasses('text-neutral-400', applyClass(activeTab === 'chat', 'text-textPrimary'))}
        type="p-md"
      >
        Chat
      </Text>
    </XStack>
    <XStack
      className={concatClasses(
        'p-md cursor-pointer border-b-1',
        applyClass(activeTab === 'summary', 'border-borderSecondary', 'border-b-transparent'),
      )}
      onClick={() => setActiveTab('summary')}
    >
      <Text
        className={concatClasses('text-neutral-400', applyClass(activeTab === 'summary', 'text-textPrimary'))}
        type="p-md"
      >
        Summary
      </Text>
    </XStack>
  </XStack>
);
